import { X } from "lucide-react";
import React from "react";
import "./CloseModalButton.scss";
interface Props {
  onClick: any;
}
const CloseModalButton = (props: Props) => {
  const { onClick } = props;
  return (
    <span className="close-modal-button" onClick={onClick}>
      <X size={16} />
    </span>
  );
};

export default CloseModalButton;
